import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ClockIcon } from 'lucide-react';
export function UrgencyBanner() {
  const [spotsTaken, setSpotsTaken] = useState(83);
  const [timeLeft, setTimeLeft] = useState({
    h: 0,
    m: 53,
    s: 58
  });
  useEffect(() => {
    const timer = window.setInterval(() => {
      setTimeLeft(current => {
        const seconds = Math.max(0, current.h * 3600 + current.m * 60 + current.s - 1);
        return {
          h: Math.floor(seconds / 3600),
          m: Math.floor(seconds % 3600 / 60),
          s: seconds % 60
        };
      });
    }, 1000);
    return () => window.clearInterval(timer);
  }, []);
  useEffect(() => {
    const timer = window.setInterval(() => setSpotsTaken(current => Math.min(current + 1, 95)), 45000);
    return () => window.clearInterval(timer);
  }, []);
  const format = (value: number) => value.toString().padStart(2, '0');
  const time = `${format(timeLeft.h)}:${format(timeLeft.m)}:${format(timeLeft.s)}`;
  return <div className="sticky top-0 z-50 w-full border-b border-brand-gold/40 bg-brand-blueDeep text-brand-cream shadow-md" data-id="element-307" data-mp="27fhxj725nkg7">
      <div className="mx-auto max-w-7xl px-3 py-2.5 md:px-6" data-id="element-308" data-mp="22motkleigg56">
        <div className="hidden items-center justify-center gap-5 text-sm font-medium md:flex" data-id="element-309" data-mp="1xo5265h5ec5f">
          <div className="flex items-center gap-2 text-brand-goldLight" data-id="element-310" data-mp="1sqlhontux351">
            <ClockIcon className="h-4 w-4" data-id="element-311" data-mp="2qdc2na05xbtb" />
            <span data-id="element-312" data-mp="2qc9f9c21tri5">PRECIO DE LANZAMIENTO CIERRA EN:</span>
            <span className="rounded bg-white/15 px-2 py-0.5 font-mono font-bold tabular-nums text-white" data-id="element-313" data-mp="2ler219h00q4c">{time}</span>
          </div>
          <span className="h-4 w-px bg-white/25" data-id="element-314" data-mp="2ge3bsq0lgdb6" />
          <span data-id="element-315" data-mp="2cdt7riwd3wyy">
            <strong className="text-brand-amber" data-id="element-316" data-mp="2cece02cngwx5">{spotsTaken}%</strong> de cupos tomados
          </span>
          <a href="#comprar" className="rounded-full bg-brand-amber px-3 py-1 text-xs font-bold text-brand-blueDeep transition-colors duration-150 ease-out hover:bg-brand-goldLight" data-id="element-317" data-mp="150r609l9xkmd">
            VER EL KIT →
          </a>
        </div>
        <div className="relative overflow-hidden md:hidden" data-id="element-318" data-mp="12dyvo5li9kp6">
          <motion.div className="flex w-max items-center gap-5 whitespace-nowrap text-[11px] font-semibold" animate={{
          x: ['0%', '-50%']
        }} transition={{
          duration: 16,
          ease: 'linear',
          repeat: Infinity
        }} data-id="element-319" data-mp="17ee54m2o281v">
            {[0, 1].map(item => <React.Fragment key={item} data-id="element-320" data-mp="jojtg7u32pj7">
                <span data-id="element-321" data-mp="jnh25ysuml2r">
                  ⏰ Cierra en <strong data-id="element-322" data-mp="oga8us7vo3hh">{time}</strong>
                </span>
                <span data-id="element-323" data-mp="ohv5cndr5whz">•</span>
                <span data-id="element-324" data-mp="9rnscn6il5oo">
                  <strong className="text-brand-amber" data-id="element-325" data-mp="9sgsh5aywwxu">{spotsTaken}%</strong> de cupos tomados
                </span>
                <a href="#comprar" className="rounded-full bg-brand-amber px-2.5 py-1 text-brand-blueDeep" data-id="element-326" data-mp="eqqrxs3q6jp9">
                  VER EL KIT →
                </a>
              </React.Fragment>)}
          </motion.div>
        </div>
      </div>
    </div>;
}